export const Liip = () => {
  return (
    <svg width="83" height="30" viewBox="0 0 83 30" fill="none" className="header__liip">
      <path
        className="header__liip__p1"
        d="M0.213236 1.66667H6.97794V22.8431H18.5466V28.7255H0.213236V1.66667Z"
        fill="currentColor"
      />
      <path
        className="header__liip__p2"
        d="M36.5858 0.294118L42.5662 3.23529L28.9387 29.6078L22.8603 26.6667L36.5858 0.294118Z"
        fill="currentColor"
      />
      <path
        className="header__liip__p3"
        d="M52.2721 0.294118L58.3505 3.23529L44.723 29.6078L38.6446 26.6667L52.2721 0.294118Z"
        fill="currentColor"
      />
      <path
        className="header__liip__p4"
        d="M69.4289 19.1176V28.7255H62.6642V1.66667H73.5466C79.625 1.66667 82.9583 5.98039 82.9583 10.3922C82.9583 14.902 79.723 19.1176 73.5466 19.1176H69.4289ZM69.4289 7.64706V13.1373H73.2525C75.1152 13.1373 76.1936 11.7647 76.1936 10.3922C76.1936 9.01961 75.1152 7.64706 73.2525 7.64706H69.4289Z"
        fill="currentColor"
      />
    </svg>
  );
};
